var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnRoundCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#007BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70711 13.2929C6.31658 12.9024 5.68342 12.9024 5.29289 13.2929C4.90237 13.6834 4.90237 14.3166 5.29289 14.7071L6.70711 13.2929ZM11 19L10.2929 19.7071L11 20.4142L11.7071 19.7071L11 19ZM21.7071 9.70711C22.0976 9.31658 22.0976 8.68342 21.7071 8.29289C21.3166 7.90237 20.6834 7.90237 20.2929 8.29289L21.7071 9.70711ZM5.29289 14.7071L10.2929 19.7071L11.7071 18.2929L6.70711 13.2929L5.29289 14.7071ZM11.7071 19.7071L21.7071 9.70711L20.2929 8.29289L10.2929 18.2929L11.7071 19.7071Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnRoundCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-round-check.aaa5b72b.svg";
export { ForwardRef as ReactComponent };